import { Icon } from '@iconify/react';
import React, { useEffect, useState } from 'react';
import { pageTitle } from '../../helper';
import Div from '../Div';
import PageHeading from '../PageHeading';
import SectionHeading from '../SectionHeading';
import Spacing from '../Spacing';
import ContactInfoWidget from '../Widget/ContactInfoWidget';
import Swal from '../../utils/darkSwal';
import BASE_URL from '../../utils/api';


export default function ContactPage() {
  pageTitle('Contact Us');
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [reason, setReason] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleContactSubmit = async () => {
    if (!fullName || !email || !reason || !phoneNumber || !message) {
      Swal.fire({
        icon: 'warning',
        title: 'Missing Fields',
        text: 'Please fill in all the fields.',
        confirmButtonColor: '#1344af',
      });
      return;
    }

    Swal.fire({
      title: 'Please wait...',
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const response = await fetch(`${BASE_URL}/api/contact/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          fullName,
          email,
          reason,
          phoneNumber,
          message,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        Swal.fire({
          icon: 'success',
          title: 'Message Sent!',
          text: data.message || 'Thank you for contacting us.',
          confirmButtonColor: '#1344af',
        });

        // Clear form fields
        setFullName('');
        setEmail('');
        setReason('');
        setPhoneNumber('');
        setMessage('');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: data.message || 'An error occurred. Please try again.',
          confirmButtonColor: '#1344af',
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Network Error',
        text: 'Could not connect to the server.',
        confirmButtonColor: '#1344af',
      });
    }
  };
  return (
    <>
      <PageHeading
        title="Contact Us"
        bgSrc="/images/contact_hero_bg.jpeg"
        pageLinkText="Contact"
      />
      <Spacing lg="150" md="80" />
      <Div className="container">
        <Div className="row">
          <Div className="col-lg-6">
            <SectionHeading
              title="Do you have a project <br/>in your mind?"
              subtitle="Getting Touch"
            />
            <Spacing lg="55" md="30" />
            <ContactInfoWidget withIcon />
            <Spacing lg="0" md="50" />
          </Div>
          <Div className="col-lg-6">
            <form action="#" className="row">
              <Div className="col-sm-6">
                <label className="cs-primary_color">Full Name*</label>
                <input type="text" className="cs-form_field" value={fullName} onChange={(e) => setFullName(e.target.value)} />
                <Spacing lg="20" md="20" />
              </Div>
              <Div className="col-sm-6">
                <label className="cs-primary_color">Email*</label>
                <input type="text" className="cs-form_field" value={email} onChange={(e) => setEmail(e.target.value)} />                <Spacing lg="20" md="20" />
              </Div>
              <Div className="col-sm-6">
                <label className="cs-primary_color">Subject*</label>
                <input type="text" className="cs-form_field" value={reason} onChange={(e) => setReason(e.target.value)} />
                <Spacing lg="20" md="20" />
              </Div>
              <Div className="col-sm-6">
                <label className="cs-primary_color">Mobile*</label>
                <input type="text" className="cs-form_field" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} />
                <Spacing lg="20" md="20" />
              </Div>
              <Div className="col-sm-12">
                <label className="cs-primary_color">Message*</label>
                <textarea className="cs-form_field" cols="30" rows="7" value={message} onChange={(e) => setMessage(e.target.value)} />
                <Spacing lg="25" md="25" />
              </Div>
              <Div className="col-sm-12">
                <button
                  type="button"
                  className="cs-btn cs-style1"
                  onClick={handleContactSubmit}
                >
                  <span>Send Message</span>
                  <Icon icon="bi:arrow-right" />
                </button>
              </Div>
            </form>
          </Div>
        </Div>
      </Div>
      <Spacing lg="150" md="80" />
      <Div className="cs-google_map">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d63342.31138245345!2d79.81500585611962!3d6.927078904734319!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae2592605c3d139%3A0x1a3a5ed8bcabfd17!2sColombo!5e0!3m2!1sen!2slk!4v1717755706942!5m2!1sen!2slk"          allowFullScreen
          title="Google Map"
        />
      </Div>
      <Spacing lg="50" md="40" />
    </>
  );
}
